import { render, staticRenderFns } from "./chartManage.vue?vue&type=template&id=498ad46a&scoped=true&"
import script from "./chartManage.vue?vue&type=script&lang=js&"
export * from "./chartManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498ad46a",
  null
  
)

export default component.exports